import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";
import Button from "../../components/common/Button";
import Div from "../../components/common/Div";
import { Tex } from "react-tex";
import {
  tenzero,
  NumberToLetter,
  fixOptions,
  fixMarginQuestionButtons,
  correctColor,
  wrongColor,
  missingColor,
  LetterToNumber,
} from "../../constants/Constants";
import Image from "../../components/common/Image";
import QuestionText from "../Partials/QuestionText";
import { Lightbulb } from "@mui/icons-material";
import { Typography } from "@mui/material";
import {formatLatexText} from "../../utils/formatLaTex";

export default function Res_MultipleChoice(props) {
  const question = props.question;
  const type = //this check is done because both single and T/F questions use this same partial
    question.options.length === 2 &&
    (question.options[0].text.toLowerCase() === "true" ||
      question.options[0].text.toLowerCase() === "false")
      ? "true/false"
      : "single";
  const submission = props.submission;
  const questionNumber = props.questionNumber;
  const submissionResults = props.submissionResults;

  var options;

  if (props.options === undefined) options = [];
  else options = props.options[questionNumber];

  function Options() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      const letter = NumberToLetter(i);

      const getTex = () => {
        return <Tex texContent={fixOptions("", options[i].text)} />;
      };

      const texCon = options[i].text !== null ? getTex() : <></>;

      let formattedText = formatLatexText(options[i].text);
      const value = (
        <div key={"Text".concat(letter)}>
          <div style={{ display: "flex" }}>
            <div
              style={{
                flex: 3,
                textAlign: "right",
                paddingRight: "0.5em",
                paddingTop: "-9px",
              }}
            >
              <text style={{ fontSize: "0.9rem" }}>{letter.concat(". ")}</text>
            </div>
            <div style={{ flex: 17, textAlign: "center", fontSize: "0.9rem" }}>
              <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                  {formattedText && <Latex>{options[i].text}</Latex>}
              </div>
              <Image src={options[i].url} width="150px" />
            </div>
          </div>
        </div>
      );
      arr.push(value);
    }
    return <Div>{arr}</Div>;
  }

  function colorGrade() {
    if (question.type == "true/false") {
      let num;
      if (submission[questionNumber].toLowerCase() == "true") num = 0;
      else num = 1;

      if (question.options[num].correct == 0) return wrongColor();
      else return correctColor();
    } else if (question.type == "single") {
      let temp = LetterToNumber(submission[questionNumber]);

      if (options[temp].correct == 0) return wrongColor();
      else return correctColor();
    }
  }
  const history = useHistory();

  function getButton() {
    if (question.solution.length === 0) return <></>;
    else {
      return (
        <>
          <Button
            backgroundColor={"#FFFFFF"}
            borderRadius={"5px"}
            padding={"5px"}
            width={"220px"}
            marginTop={"10px"}
            margin={"margin: 0 auto"}
            onClick={() => {
              history.push("/solution", {
                solution: question.solution,
                question: props.questionNumber,
              });
            }}
          >
            <Lightbulb></Lightbulb>
          </Button>
        </>
      );
    }
  }

  return (
    <Div
      backgroundColor={"#FFFFFF"}
      height={"100%"}
      margin={tenzero}
      borderRadius={"5px"}
      padding={"10px"}
    >
      <Div overflowY={"auto"} height={"80%"}>
        <Div margin={tenzero}>
          <Typography
            fontWeight={"bold"}
            color={"#00112e"}
            textAlign={"left"}
            padding={"10px"}
            style={{ fontSize: "1.1rem" }}
          >
            Question {questionNumber + 1}
          </Typography>
          <hr
            style={{
              borderColor: "rgb(0, 17, 46)",
              borderWidth: "1px",
              borderStyle: "solid",
              width: "95%",
            }}
          />

          <QuestionText question={question} />
        </Div>
        <Image
          src={question.url}
          width="250px"
          style={{ display: "block", margin: "0 auto" }}
        />
        {type === "single" ? Options() : ""}
      </Div>

      <div
        style={{
          backgroundColor: "#ccc",
          padding: "5px",
          borderRadius: "10px",
          margin: "20px",
        }}
      >
        <div
          style={{
            fontSize: "1rem",
            padding: "10px",
            paddingBottom: "10px",
            borderRadius: "5px",
            fontWeight: "bold",
            textAlign: "left",
            color: "rgb(0, 17, 46)",
            width: "100%",
            margin: "0 auto",
          }}
        >
          Your Answer
        </div>

        <Div padding={"10px 0"}>
          <Div
            width={"200px"}
            backgroundColor={
              submission[questionNumber] !== undefined
                ? colorGrade()
                : missingColor()
            }
            margin={"0 auto"}
            fontSize={"0.9rem"}
            padding={"10px"}
            borderRadius={"5px"}
            marginBottom={"10px"}
            style={{ marginBottom: "10px" }}
          >
            {submission[questionNumber] !== undefined
              ? submission[questionNumber]
              : "Not Answered"}
          </Div>
          {getButton()}
        </Div>
      </div>
    </Div>
  );
}
